/*

NOTE: tag is not supported in horizontal menu

Array of object

Top level object can be:
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- nav Grp (top level grp is called header group) ---/

title
icon (if it's on top/second level)
children

/--- nav Item (top level item is called header link) ---/

icon (if it's on top/second level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)

*/

export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Services',
    route: 'services-index',
    icon: 'PackageIcon',
    action: 'read',
    resource: 'services',
  },
  {
    title: 'Accounts',
    route: 'accounts-index',
    icon: 'LayersIcon',
  },
  {
    header: 'Send message',
    icon: 'MessageCircleIcon',
    children: [
      {
        title: 'Quick send',
        route: 'send-quick',
        icon: 'SendIcon',
      },
      {
        title: 'Groups',
        route: 'groups',
        icon: 'UsersIcon',
      },
      {
        title: 'Contacts',
        route: 'contacts',
        icon: 'UserIcon',
      },
      {
        title: 'Campaigns',
        route: 'campaigns-list',
        icon: 'TargetIcon',
      },

    ],
  },
  {
    title: 'Messages',
    route: 'messages-index',
    icon: 'MessageSquareIcon',
  },
  {
    header: 'Financial',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Invoices',
        route: 'invoices-index',
        icon: 'FileTextIcon',
      },
      {
        title: 'Payments',
        route: 'payments-index',
        icon: 'ShoppingBagIcon',
      },
      {
        title: 'Transactions',
        route: 'transactions-index',
        icon: 'CreditCardIcon',
      },
      {
        title: 'Bank receipts',
        route: 'bank-receipts-index',
        icon: 'ListIcon',
      },
      {
        title: 'Affiliate',
        icon: 'LinkIcon',
        action: 'read',
        resource: 'affiliates',
        children: [
          {
            title: 'Users',
            route: 'affiliate-users-index',
            icon: 'UsersIcon',
          },
          {
            title: 'Affiliate',
            route: 'affiliates-index',
            icon: 'CreditCardIcon',
          },
        ],
      },
      {
        title: 'Checkouts',
        route: 'checkouts-index',
        icon: 'CheckCircleIcon',
      },
    ],
  },
  {
    header: 'Support',
    icon: 'HeadphonesIcon',
    children: [
      {
        title: 'Faqs',
        route: 'faqs-index',
        icon: 'HelpCircleIcon',
      },
      {
        title: 'Tickets',
        route: 'tickets-index',
        icon: 'MessageCircleIcon',
      },
    ],
  },
  {
    title: 'Documents',
    route: 'documents',
    icon: 'FileMinusIcon',
  },
  {
    header: 'Admin',
    icon: 'SlashIcon',
    children: [
      {
        title: 'Users',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Users',
            route: 'users-index',
            icon: 'UsersIcon',
            action: 'read',
            resource: 'users',
          },
          {
            title: 'Resellers',
            route: 'resellers-index',
            icon: 'UserMinusIcon',
            action: 'read',
            resource: 'resellers',
          },
          {
            title: 'Roles',
            route: 'roles-index',
            icon: 'UserCheckIcon',
            action: 'read',
            resource: 'roles',
          },
        ],
      },
      {
        title: 'Panels',
        icon: 'LayersIcon',
        children: [
          {
            title: 'Panels',
            route: 'panels-index',
            icon: 'LayersIcon',
            action: 'read',
            resource: 'panels',
          },
          {
            title: 'Packages',
            route: 'packages-index',
            icon: 'PackageIcon',
            action: 'read',
            resource: 'packages',
          },
          {
            title: 'Products',
            route: 'products-index',
            icon: 'BoxIcon',
            action: 'read',
            resource: 'products',
          },
        ],
      },
      {
        title: 'Discount',
        icon: 'SaveIcon',
        children: [
          // {
          //   title: 'Discount types',
          //   route: 'discount-types-index',
          //   icon: 'TagIcon',
          //   action: 'read',
          //   resource: 'discount.types',
          // },
          {
            title: 'Discount codes',
            route: 'discount-codes-index',
            icon: 'CodeIcon',
            action: 'read',
            resource: 'discount.codes',
          },
        ],
      },
      // {
      //   title: 'Settings',
      //   icon: 'SettingsIcon',
      //   children: [
      //     {
      //       title: 'Settings',
      //       route: 'settings-index',
      //       icon: 'SettingsIcon',
      //       action: 'read',
      //       resource: 'settings',
      //     },
      //   ],
      // },
    ],
  },
]
